import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {getGraph, setActiveTimeframe} from "../store/actions/graphActions";
import GraphItem from './graph/graphItem.jsx';
import {nest} from "d3-collection";
import {getOrders} from "../store/actions/ordersActions";

function Graph(props) {

    // Импорт диспатчера
    const dispatch = useDispatch();

    // Подписка на изменение стейта графика
    const timeframe = useSelector(state => state.graph.activeTimeframe);
    const graph = useSelector(state => state.graph.items);
    const storeFilteredGraph = graph.filter(candle => candle.candle.interval === timeframe);
    const orders = useSelector(state => state.orders.items);

    // Получение данных графика
    useEffect(() => {
        dispatch(getGraph());
    }, []);

    if (props.demo) {
        // Получение списка ордеров
        useEffect(() => {
            dispatch(getOrders());
        }, []);
    }

    // Установка ширины и высоты графика: хуки для передачи значений в график
    const [chartHeight, updateChartHeight] = useState(setChartHeight());
    const [chartWidth, updateChartWidth] = useState(setChartWidth());

    // Установка ширины и высоты графика: лиссенер на ресайз
    function setChartSize() {
        let resizeTimer = undefined;
        let delay = 1000;

        window.addEventListener('resize', () => {
            if (!resizeTimer) {
                resizeTimer = setTimeout(() => {
                    updateChartHeight(setChartHeight());
                    updateChartWidth(setChartWidth());
                    resizeTimer = undefined;
                }, delay);
            }
        });


    }

    // Установка ширины и высоты графика: расчет ширины
    function setChartWidth() {
        let maxWidth = 1230;
        let minWidth = 300;

        let width = window.innerWidth - 20;

        if (width < minWidth) {
            width = minWidth;
        } else if (width > maxWidth) {
            width = maxWidth;
        }

        return width;
    }

    // Установка ширины и высоты графика: расчет высоты
    function setChartHeight() {
        let maxHeight = 600;
        let minHeight = 400;

        let height = window.innerHeight - 100;

        if (height < minHeight) {
            height = minHeight;
        } else if (height > maxHeight) {
            height = maxHeight;
        }

        return height;
    }

    // Установка ширины и высоты графика: однократный вызов лиссенера
    useEffect(() => {
        setChartSize();
    }, []);

    // Подмешивание закрытых ордеров к массиву свечей
    function mixOrders() {
        let filteredGraph = storeFilteredGraph;

        const groupCandles = nest()
            .key(candle => candle.daymth)
            .entries(filteredGraph);

        function closestCandle(orderTime, candles) {
            let closest = null;
            let minOpenTime = null;

            candles.forEach(item => {
                let openTime = item.open_time;

                if (minOpenTime === null) {
                    minOpenTime = openTime;
                } else if (openTime <= minOpenTime) {
                    minOpenTime = openTime;
                }

                if (openTime <= orderTime && (closest == null || (orderTime - openTime) < (orderTime - closest))) {
                    closest = openTime;
                }
            });

            if (closest === null) {
                closest = minOpenTime;
            }

            return closest;
        }

        let closedOrders = orders.filter(order => order.status === 'FILLED' || order.status === 'CANCELED' || order.status === 'PENDING_CANCEL' || order.status === 'REJECTED' || order.status === 'EXPIRED');

        for (let order of closedOrders) {
            let filteredCandles;

            if (timeframe === '3d') {
                filteredCandles = filteredGraph;
            } else {
                filteredCandles = groupCandles.filter(candles => candles.key === order.daymth);
            }

            if (filteredCandles.length !== 0) {
                if (timeframe !== '3d') {
                    filteredCandles = filteredCandles[0].values;
                }

                let candleTime = closestCandle(order.date_number, filteredCandles);

                let candleIndex = filteredGraph.findIndex(candle => candle.open_time === candleTime);
                let orderObj = {
                    price: +order.orderPrice,
                    type: order.side,
                    status: order.status
                };

                filteredGraph[candleIndex].candle.orders.push(orderObj);
            }
        }

        return filteredGraph;
    }


    // Функция формирования массива открытых ордеров
    function groupOpenOrders() {
        let groupedOpenOrders = [];
        let fullGroupOpenOrders = nest()
            .key(order => order.orderId)
            .entries(orders.filter(order => order.status !== 'FILLED' && order.status !== 'CANCELED'));

        for (let orders of fullGroupOpenOrders) {
            let order = orders.values[0];

            let type = 'buy';

            if (order.side === 'SELL') {
                type = 'sell';
            }

            let orderObj = {
                price: +order.orderPrice,
                type: type,
                open_time: new Date(+order.sdTime),
                idx: {index: order.orderId}
            };

            groupedOpenOrders.push(orderObj);
        }

        return groupedOpenOrders;
    }

    // Преобразуем сгруппированный массив свечей в обычный плоский массив для графика
    let candlesWithOrders = mixOrders().map(candle => {
        return candle.candle;
    });

    function SetGraphItem() {

        if (candlesWithOrders.length === 0) {
            return (
                <div className={'chart__item'} style={{height: chartHeight + 'px'}}>
                    <div className={'chart__load'}/>
                </div>
            );
        }

        return (
            <div className={'chart__item'}>
                <GraphItem
                    height={chartHeight}
                    width={chartWidth}
                    ratio={1}
                    type={'hybrid'}
                    data={candlesWithOrders}
                    orders={orders}
                    openOrders={groupOpenOrders()}
                    demo={props.demo}
                />
            </div>
        );
    }


    return (
        <div className={'chart'}>
            <SetGraphItem/>
        </div>
    );
}

export default Graph;
